module.exports = __webpack_public_path__ + "static/media/image4.e3051057.jpg";